import React from 'react';
import { TableCell, TableRow, Autocomplete, TextField, Chip} from '@mui/material';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import styled from 'styled-components';

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const CMreadonlyrow = ({k,onChangeSub, row,onClickAddSubCateg, onClickEdit,handleDeleteClick, tableFontSize, SubmitButton,
   page, rowsPerPage, editCategory, subject}) =>{
    
    return(        
        <>
         <TableRow key={k} name={row.categ}>
            <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
            {(page)*(rowsPerPage)+k+1}
            </TableCell>
         <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
          {row?.Category}
         </TableCell>
        <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            size='small'
            value={subject[`subject${(page)*(rowsPerPage)+k}`]?.data}
            onChange={(event, newValue)=>onChangeSub(event, newValue, `subject${(page)*(rowsPerPage)+k}`,k)}
            options={row?.Subject? row?.Subject:[]}
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
            renderInput={(params) => <TextField {...params} label={"Select Subject"} />}
            />        
            </TableCell>
            <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
              {row?.ApplAssetCateg? row?.ApplAssetCateg?.map((item,key)=> <Chip key={key} label={item} sx={{marginRight:"2px", marginBottom:"2px"}}/>):null}
          
            </TableCell>
            <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
              {row?.ApplAssetCateg? row?.AppAssets?.map((item,key)=> <Chip key={key} label={item} sx={{marginRight:"2px", marginBottom:"2px"}}/>):null}
          
            </TableCell>

            <TableCell align="left" sx={{ fontSize: tableFontSize}}>
              <ButtonWrapper>
                <SubmitButton type='button' style={{backgroundColor:"#ed6c02", color:"lightgreen", height:"35px", margin:"0px"}} onClick ={(e)=>onClickEdit(e,k,subject[`subject${(page)*(rowsPerPage)+k}`])}>Edit</SubmitButton>
                <SubmitButton type='button' style={{backgroundColor:"#D32F2F", color:"lightgreen", height:"35px"}}  onClick ={(e)=>handleDeleteClick(e,k, row._id)}>Delete</SubmitButton>
                <SubmitButton type='button' style={{height:"35px"}}  onClick={(e)=>onClickAddSubCateg(e,k)}>Add Subject</SubmitButton>
              </ButtonWrapper>                          
            </TableCell>
          </TableRow>     
        </>        
    )
}

export default CMreadonlyrow;